'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	_ = require('underscore');

module.exports = function SubscriptionPlanModel(plans) {
	// let domainRegistrationDisabled,
	let filteredPlans,
		currentFilter = {
			CCY: plans[0].CCY
		},
		currentPlan;
	const self = observable(this),
		planIsValid = function (plan) {
			if (!plan || !plan.id || !filteredPlans && !filteredPlans.length) {
				return false;
			}
			return !!_.find(filteredPlans, function (toFind) {
				return toFind.id === plan.id;
			});
		},
		setCurrentPlan = function (plan) {
			if (plan === currentPlan) {
				return;
			}
			currentPlan = plan;
			self.dispatchEvent('planSelected', plan);
		},
		filterPlans = function (filter) {
			if (!filter) {
				throw new Error('must set filter');
			}
			const canDoAction = function (action) {
					if (!filter.actions) {
						return true;
					}

					return filter.actions.includes(action);
				},
				newFilteredPlans = plans
					.filter(plan => plan.CCY === filter.CCY)
					.filter(plan => canDoAction(plan.purchaseAction));


			currentFilter = filter;
			if (filteredPlans && !_.difference(filteredPlans, newFilteredPlans).length && !_.difference(newFilteredPlans, filteredPlans).length) {
				return;
			}
			filteredPlans = newFilteredPlans;
			if (!planIsValid(currentPlan)) {
				setCurrentPlan((!!filteredPlans.length && filteredPlans[0]));
			}
			self.dispatchEvent('subscriptionPlansChanged', filteredPlans, currentPlan);
		};
	self.getSelectedPlan = function () {
		return currentPlan;
	};
	self.findPlanForPredicate = predicate => {
		return plans.find(predicate);
	};
	self.availablePlans = function () {
		return filteredPlans && filteredPlans.slice(0);
	};
	self.setSelectedPlan = function (plan) {
		if (!plan || !plan.id || !planIsValid(plan)) {
			return false;
		}
		setCurrentPlan(plan);
		return true;
	};
	self.filterPlans = function (actions) {
		filterPlans({actions: actions, CCY: currentFilter.CCY});
	};
	self.getSelectedCurrency = () => {
		return currentPlan.CCY;
	};
	self.setSelectedCurrency = (currency) => {
		if (!plans.map(p => p.CCY).includes(currency)) {
			throw new Error('invalid-args');
		}
		self.dispatchEvent('currencySelected', currency);
		return filterPlans(Object.assign({}, currentFilter, {CCY: currency}));
	};
	self.getAvailableCurrencies = () => {
		return Array.from(new Set(plans.map(p => p.CCY)));
	};
	self.getUpgradePlan = (allowedActions, planType) => {
		const found = plans.find(thisPlan => {
			return thisPlan.requireUpgradeAction && thisPlan.type === planType && allowedActions.includes(thisPlan.requireUpgradeAction);
		});
		return found;
	};

	filterPlans(currentFilter);
};
